/* eslint-disable no-unused-vars */
export enum CommunicationScheduleStatus {
  Processing = 1,
  Sent = 2,
  Discarded = 3,
  Canceled = 4,
}
